// extracted by mini-css-extract-plugin
export default {"cls1":"ResearchInterestTags-cls1_sp2","cls2":"ResearchInterestTags-cls2_MMJ ResearchInterestTags-cls1_sp2"};